import { render, staticRenderFns } from "./ElementsGrid.vue?vue&type=template&id=0baae4e0"
import script from "./ElementsGrid.vue?vue&type=script&lang=js"
export * from "./ElementsGrid.vue?vue&type=script&lang=js"
import style0 from "./ElementsGrid.vue?vue&type=style&index=0&id=0baae4e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports